import React, { useMemo, useCallback } from 'react';
import {
  Table,
} from 'reactstrap';

import LaboralBulkLoadAraucoDocxMergeFieldFormItem from './form_item';

const LaboralBulkLoadAraucoDocxMergeFieldFormList = (props) => {
  const {
    data,
    callbacks,
    errors
  } = props;

  const {
    onSetBulkLoadCallback
  } = callbacks;

  const associatedMergeFields = useMemo(() => {
    return props.associatedMergeFields
  }, [props.associatedMergeFields])

  const onChangeAssociatedMergeField = useCallback((mergeField, value) => {
    onSetBulkLoadCallback(prevState => {
      return {
        ...prevState,
        associatedMergeFields: _.map(prevState.associatedMergeFields, associatedMergeField => {
          if(associatedMergeField.mergeField === mergeField){
            return {
              ...associatedMergeField,
              header: value
            };
          }
          return associatedMergeField;
        })
      }
    })
  }, [onSetBulkLoadCallback]);

  const memoizedCallbacks = useMemo(() => ({
    onChangeAssociatedMergeFieldCallback: onChangeAssociatedMergeField
  }), [onChangeAssociatedMergeField]);

  return(
    <Table>
      <thead>
        <tr>
          <th>Variable Plantilla</th>
          <th>Cabecera Archivo de datos</th>
        </tr>
      </thead>

      <tbody>
        { _.map(associatedMergeFields, associatedMergeField => {
          return (
            <LaboralBulkLoadAraucoDocxMergeFieldFormItem
              key={ `tr-${ associatedMergeField.mergeField }` }
              associatedMergeField={ associatedMergeField }
              data={ data }
              callbacks={ memoizedCallbacks }
              errors={ errors }
            />
          )
        }) }
      </tbody>
    </Table>
  )
}

export default React.memo(LaboralBulkLoadAraucoDocxMergeFieldFormList);
